// Entry point. Two mount paths:
//   1. Demo mode  — mounts into #root in index.html, auto-loads demo storyboard.
//   2. Embed mode — mounts into #orb-stage-v3 inside voice_agent.html (the
//      live concierge page). Skips demo auto-load, subscribes to window
//      CustomEvents dispatched by voice_agent.html's WebSocket handler.
//
// Embed events consumed (see voice_agent.html present_story handler):
//   concierge:storyboard      detail = { storyboard }
//   concierge:interrupt       detail = none           (barge-in / speech_started)
//   concierge:advance         detail = none           (signal_stage_event advance)

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './theme/globals.css';

const embedMount = document.getElementById('orb-stage-v3');
const demoMount  = document.getElementById('root');
const mount = embedMount ?? demoMount;
const embedMode = !!embedMount;

if (!mount) {
  console.error('[v3] no mount point found (#orb-stage-v3 or #root)');
} else {
  createRoot(mount).render(
    <StrictMode>
      <App embedMode={embedMode} />
    </StrictMode>,
  );
}
